// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"CustomTooltip_tooltip__2hjTP","tooltipTitle":"CustomTooltip_tooltipTitle__vI1BM","tooltipRow":"CustomTooltip_tooltipRow__Ihwh_"};